import Header from "../../components/common/Header";
import About from "../../components/picdict/About";
import ContactForm from "../../components/common/Contact";
import Footer from "../../components/common/Footer";
import HowTo from "../../components/picdict/HowTo";
import { Helmet } from "react-helmet";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ textAlign: "center", mb: 6 }}>
    <Typography
      variant="h4"
      component="h2"
      sx={{
        fontWeight: 700,
        color: "#0F172A",
        display: "inline-block",
        position: "relative",
        pb: 1.5,
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: 36,
          height: 3,
          backgroundColor: "#3B82F6",
          borderRadius: 2,
        },
      }}
    >
      {children}
    </Typography>
  </Box>
);

function PicDict() {
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#F1F5F9" }}>
      <Helmet
        title="PicDict"
        link={[{ rel: "canonical", href: "https://matsuki-takeshi.com/picdict/about" }]}
        meta={[
          {
            name: "description",
            content: "PicDictについての使用方法の説明。",
          },
          {
            property: "og:description",
            content: "PicDictの使用方法の説明。",
          },
          { property: "og:title", content: "PicDict" },
          { property: "og:type", content: "使用方法の説明" },
          { property: "og:url", content: "https://matsuki-takeshi.com/picdict/about" },
          { property: "keywords", content: "picdict" },
        ]}
      />
      <Header />

      {/* Page hero */}
      <Box
        sx={{
          backgroundColor: "#1E293B",
          py: { xs: 5, md: 7 },
          textAlign: "center",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              color: "#FFFFFF",
              mb: 1,
              fontSize: { xs: "1.75rem", md: "2.25rem" },
            }}
          >
            PicDict
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: "0.95rem" }}>
            画像で覚える単語帳アプリ
          </Typography>
        </Container>
      </Box>

      {/* About Section */}
      <Box component="section" sx={{ backgroundColor: "#FFFFFF", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <SectionTitle>About</SectionTitle>
          <About />
        </Container>
      </Box>

      {/* How To Section */}
      <Box component="section" sx={{ backgroundColor: "#F8FAFC", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <SectionTitle>How To</SectionTitle>
          <HowTo />
        </Container>
      </Box>

      {/* Contact Section */}
      <Box component="section" sx={{ backgroundColor: "#FFFFFF", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <SectionTitle>Contact</SectionTitle>
          <ContactForm />
        </Container>
      </Box>

      <Footer />
    </Box>
  );
}

export default PicDict;
